var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChevron = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 8,
  fill: "none",
  viewBox: "0 0 13 8"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.09.59 6.5 5.17 1.91.59.5 2l6 6 6-6z"
})));
export { SvgChevron as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEzIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMS4wOSAwLjU4OTg0NEw2LjUgNS4xNjk4NEwxLjkxIDAuNTg5ODQ0TDAuNSAxLjk5OTg0TDYuNSA3Ljk5OTg0TDEyLjUgMS45OTk4NEwxMS4wOSAwLjU4OTg0NFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";